/* tslint:disable */
/* eslint-disable */
/**
 * BROStar API
 * Simplify the data management of the BRO
 *
 * The version of the OpenAPI document: v1
 * Contact: servicedesk@nelen-schuurmans.nl
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface GeoElectricMeasurement
 */
export interface GeoElectricMeasurement {
  /**
   *
   * @type {string}
   * @memberof GeoElectricMeasurement
   */
  readonly uuid?: string;
  /**
   *
   * @type {Date}
   * @memberof GeoElectricMeasurement
   */
  readonly created?: Date;
  /**
   *
   * @type {Date}
   * @memberof GeoElectricMeasurement
   */
  readonly updated?: Date;
  /**
   *
   * @type {Date}
   * @memberof GeoElectricMeasurement
   */
  measurementDate?: Date | null;
  /**
   *
   * @type {string}
   * @memberof GeoElectricMeasurement
   */
  determinationProcedure?: string | null;
  /**
   *
   * @type {string}
   * @memberof GeoElectricMeasurement
   */
  evaluationProcedure?: string | null;
  /**
   *
   * @type {string}
   * @memberof GeoElectricMeasurement
   */
  frd: string;
  /**
   *
   * @type {string}
   * @memberof GeoElectricMeasurement
   */
  dataOwner: string;
}

/**
 * Check if a given object implements the GeoElectricMeasurement interface.
 */
export function instanceOfGeoElectricMeasurement(value: object): value is GeoElectricMeasurement {
  if (!("frd" in value) || value["frd"] === undefined) return false;
  if (
    (!("dataOwner" in (value as Record<string, any>)) &&
      !("data_owner" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["dataOwner"] === undefined &&
      (value as Record<string, any>)["data_owner"] === undefined)
  )
    return false;
  return true;
}

export function GeoElectricMeasurementFromJSON(json: any): GeoElectricMeasurement {
  return GeoElectricMeasurementFromJSONTyped(json, false);
}

export function GeoElectricMeasurementFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): GeoElectricMeasurement {
  if (json == null) {
    return json;
  }
  return {
    uuid: json["uuid"] == null ? undefined : json["uuid"],
    created: json["created"] == null ? undefined : new Date(json["created"]),
    updated: json["updated"] == null ? undefined : new Date(json["updated"]),
    measurementDate:
      json["measurement_date"] === undefined
        ? undefined
        : json["measurement_date"] === null
        ? null
        : new Date(json["measurement_date"]),
    determinationProcedure:
      json["determination_procedure"] === undefined
        ? undefined
        : json["determination_procedure"] === null
        ? null
        : json["determination_procedure"],
    evaluationProcedure:
      json["evaluation_procedure"] === undefined
        ? undefined
        : json["evaluation_procedure"] === null
        ? null
        : json["evaluation_procedure"],
    frd: json["frd"],
    dataOwner: json["data_owner"],
  };
}

export function GeoElectricMeasurementToJSON(json: any): GeoElectricMeasurement {
  return GeoElectricMeasurementToJSONTyped(json, false);
}

export function GeoElectricMeasurementToJSONTyped(
  value?: Omit<GeoElectricMeasurement, "uuid" | "created" | "updated"> | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    measurement_date:
      value["measurementDate"] == null
        ? value["measurementDate"]
        : value["measurementDate"].toISOString().substring(0, 10),
    determination_procedure: value["determinationProcedure"],
    evaluation_procedure: value["evaluationProcedure"],
    frd: value["frd"],
    data_owner: value["dataOwner"],
  };
}
